module.exports = __webpack_public_path__ + "img/logo2.995d648d.png";